module.exports = __webpack_public_path__ + "img/Unidad1-1.95e12aa4.png";